<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('scoreComponent.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('scoreComponent.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            outline
            color="info"
            @click.prevent="() => (show_form = true)"
            >{{ $t('add_new') }}</ts-button
          >
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <!-- table list -->
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td>{{ record.score_component }}</td>
            <td>
              {{
                record.main_program
                  ? record.main_program.acp_name_foreign
                  : null
              }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <a href="#" class="text-primary" @click.prevent="edit(record)">
                <i class="fa fa-edit"></i>
              </a>
            </td>
          </template>
          <div slot="expand" slot-scope="prop">
            <ul class="nav nav-inbox">
              <li
                class="mr-2"
                v-for="(component, index) in prop.record.component_items"
                :key="index"
              >
                <span class="badge badge-primary pull-left mr-2">
                  {{ index + 1 }}
                </span>
                <strong>{{ component.sc_item_name }}</strong>
              </li>
            </ul>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form action -->
      <a-modal
        v-if="show_form"
        v-model="show_form"
        :title="$t('scoreComponent.pageTitle')"
        :zIndex="1020"
        :footer="null"
        :maskClosable="false"
        @cancel="clearInput"
        width="400px"
      >
        <form-component v-model="model" :validate="errors">
          <template v-slot:action-button>
            <ts-button class="mr-2" @click.prevent="cancelCreate">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button
              v-if="model.sc_id == 0"
              class="mr-2"
              color="primary"
              outline
              :waiting="waiting_new"
              @click.prevent="saveNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              v-if="model.sc_id == 0"
              color="primary"
              :waiting="waiting"
              @click.prevent="save"
              >{{ $t('save') }}</ts-button
            >
            <ts-button
              v-if="model.sc_id != 0"
              color="primary"
              :waiting="waiting"
              @click.prevent="onUpdate"
              >{{ $t('update') }}</ts-button
            >
          </template>
        </form-component>
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'
import FormComponent from './form'

export default {
  name: 'scoreComponent',
  components: {
    FormComponent
  },
  data() {
    return {
      loading: false,
      show_form: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        acp_id: null,
        sc_id: 0,
        score_component: null,
        grade_id_list: [],
        score_component_list: [
          {
            sc_item_id: 0,
            sc_item_name: ''
          }
        ]
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('scoreComponent', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.scoreComponent.search
      },
      set(newValue) {
        this.$store.commit('scoreComponent/SET_SEARCH', newValue)
        this.$store.commit('scoreComponent/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('scoreComponent.componentName'), style: 'width:70%' },
        { name: this.$t('scoreComponent.mainProgram') },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  methods: {
    ...mapActions('scoreComponent', ['store', 'update']),
    save() {
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.show_form = false
          this.clearInput()
          this.fetchData()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    saveNew() {
      this.waiting_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.fetchData()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.update({
        id: this.model.sc_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.show_form = false
          this.clearInput()
          this.fetchData()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('scoreComponent/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.model.acp_id = record.acp_id
      this.model.sc_id = record.sc_id
      this.model.grade_id_list = record.grade_id_list
      this.model.score_component = record.score_component
      this.model.score_component_list = record.component_items.map(el => ({
        display_order: el.display_order,
        sc_item_id: el.sc_item_id,
        sc_item_name: el.sc_item_name
      }))
      this.show_form = true
    },
    cancelCreate() {
      this.show_form = false
      this.clearInput()
    },
    clearInput() {
      this.errors = new Errors()
      this.model.acp_id = null
      this.model.sc_id = 0
      this.model.score_component = null
      this.model.grade_id_list = []
      this.model.score_component_list = []
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('scoreComponent/RESET_STATE')
    next()
  }
}
</script>
